import { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { motion } from "motion/react";

import FnrShineButton from "../FnrShineButton";

export default function NavItem({
  icon,
  title,
  itemKey,
  selectedItem,
  setSelectedItem,
  isGroup,
}) {
  return (
    <FnrShineButton>
      <Wrapper>
        <Inside>
          <Icon>
            <i className={icon} />
          </Icon>
          <Title>{title}</Title>
        </Inside>
      </Wrapper>
    </FnrShineButton>
  );
}
const Wrapper = styled.div`
  display: flex;
  padding: 4px 12px;
  cursor: pointer;
  position: relative;
  margin: 0 12px;
`;
const Inside = styled(motion.div)`
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 20px;
  text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;
`;
const Icon = styled.div`
  width: 20px;
  font-size: 16px;
  text-align: center;
`;
const Title = styled.div`
  font-size: 14px;
  position: relative;
`;
